<template>
  <slot />
</template>

<script>
import { onMounted } from 'vue'
import { useAccessibility } from '../utils/accessibility.js'

export default {
  name: 'AccessibilityProvider',
  setup() {
    const { loadSettings, applySettings } = useAccessibility()

    onMounted(() => {
      // Load and apply accessibility settings on app startup
      loadSettings()
      applySettings()
    })

    return {}
  }
}
</script>
